import themeGet from '@styled-system/theme-get';
import styled from 'styled-components/macro';

import { Text } from '@olist/united';

const Description = styled(Text.Small)`
  color: ${themeGet('colors.foundation.shadeDarker')};
  line-height: 1.3;
  margin-top: ${themeGet('space.2')}px;
`;

const StepDescription = (props) => <Description {...props} />;

export default StepDescription;
